import type {RefObject} from 'react';
import {useLayoutEffect, useState} from 'react';
import {Page} from '@PosterWhiteboard/page/page.class';

/**
 * Item popups are positioned in a layer above the pages, so a popup for an item on page N adds how
 * far page N's backdrop sits below that layer. Measured against the layer itself before paint: the
 * pages' canvas elements are offset within their own page and shift as it scrolls, and even the
 * first page's backdrop moves relative to the layer when another page becomes current. Until the
 * layer has mounted, the offset from the first page's backdrop stands in.
 */
export function usePageOffsetInPopupLayer(popupLayerRef: RefObject<HTMLElement | null>, pageId: string, isPopupOpen: boolean): number {
  const [measuredOffset, setMeasuredOffset] = useState<number | null>(null);

  useLayoutEffect((): void => {
    const popupLayer = popupLayerRef.current;
    if (!isPopupOpen || !popupLayer || !pageId) {
      setMeasuredOffset(null);
      return;
    }
    setMeasuredOffset(Page.getPageOffsetFromElement(pageId, popupLayer));
  }, [popupLayerRef, pageId, isPopupOpen]);

  return measuredOffset ?? Page.getPageOffsetFromFirstPage(pageId);
}
